import React, {Suspense, lazy} from 'react'
import {Routes, Route, Navigate, useLocation} from 'react-router-dom'
import { FallbackView } from '@/__core/partials/FallbackView'

import { ProtectedRoute } from './ProtectedRoute'
import InventoryStockTransactionPage from '../pages/inventory/stock_transaction'
import ReportFinancialPage from '../pages/finance/ReportFinancial'

const DashboardPage = lazy(() => import('@/app/pages/dashboard/DashboardWrapper'))
const EmployeePage = lazy(() => import('@/app/pages/employee/EmployeeWrapper'))
const OrganizationPage = lazy(() => import('@/app/pages/organization/OrganizationWrapper'))
const FixedSalaryPage = lazy(() => import('@/app/pages/organization/fixedSalary'))
const InsurancePage = lazy(() => import('@/app/pages/organization/InsuranceWrapper'))
const OrdersPage = lazy(() => import('@/app/pages/orders'))
const OrderProgressPage = lazy(() => import('@/app/pages/orders/OrderProgress'))
const CustomersPage = lazy(() => import('@/app/pages/customers'))
const SuppliersPage = lazy(() => import('@/app/pages/suppliers'))
const UsersPage = lazy(() => import('@/app/pages/users'))
const RolesPage = lazy(() => import('@/app/pages/users/Roles'))
const AppsPage = lazy(() => import('@/app/apps/Apps'))
const SettingsPage = lazy(() => import('@/app/pages/settings/SettingsPage'))
const MyTasksPage = lazy(() => import('@/app/pages/tasks/MyTasksPage'))
const FinanceTransactions = lazy(() => import('@/app/pages/finance/FinanceTransactions'))
const ReportsPage = lazy(() => import('@/app/pages/reports'))
const TimekeepingPage = lazy(() => import('@/app/pages/timekeepings'))
const TimekeepingDetailPage = lazy(() => import('@/app/pages/timekeepings/detail'))
const TimesheetPage = lazy(() => import('@/app/pages/timekeepings/TimesheetWrapper'))
const MainPage = lazy(() => import('@/app/pages/main/MainPage'))
const ManageOrdersPage = lazy(() => import('@/app/pages/main/ManageOrdersPage'))
const InventoryDashboardPage = lazy(() => import('@/app/pages/inventory'))
const InventoryCatalogsPage = lazy(() => import('@/app/pages/inventory/catalogs'))
const InventoryItemsPage = lazy(() => import('@/app/pages/inventory/items'))
const InventoryStockBalancePage = lazy(() => import('@/app/pages/inventory/stock_balance'))
const InventoryStoresPage = lazy(() => import('@/app/pages/inventory/stores'))
const InventoryRequestsPage = lazy(() => import('@/app/pages/inventory/requests'))
const InventoryPurchasingPage = lazy(() => import('@/app/pages/inventory/purchasing'))
const InventoryReceiptsPage = lazy(() => import('@/app/pages/inventory/receipts'))
const InventoryAllocationPage = lazy(() => import('@/app/pages/inventory/allocation'))
const InventoryIssuesPage = lazy(() => import('@/app/pages/inventory/issues'))
const InventoryReturnsPage = lazy(() => import('@/app/pages/inventory/returns'))
const InventoryStocktakesPage = lazy(() => import('@/app/pages/inventory/stocktakes'))
const InventoryReportsPage = lazy(() => import('@/app/pages/inventory/reports'))

export function PrivateRoutes() {
  const location = useLocation();

  return (
    <ProtectedRoute>
      <Suspense fallback={<FallbackView />}>
        <Routes location={location} key={location.pathname}>
          <Route path='/dashboard' element={<DashboardPage />} />
          <Route path='/apps' element={<AppsPage />} />
          <Route path='/auth' element={<Navigate to='/main' />} />
          <Route path='/' element={<Navigate to='/main' />} />
          <Route path='/employees' element={<EmployeePage />} />
          <Route path='/organization' element={<OrganizationPage />} />
          <Route path='/fixed-salary' element={<FixedSalaryPage />} />
          <Route path='/insurance' element={<InsurancePage />} />
          <Route path='/sale-orders' element={<OrdersPage />} />
          <Route path='/order-progress' element={<OrderProgressPage />} />
          <Route path='/customers' element={<CustomersPage />} />
          <Route path='/suppliers' element={<SuppliersPage />} />
          <Route path='/users' element={<UsersPage />} />
          <Route path='/users/roles' element={<RolesPage />} />
          <Route path='/settings' element={<SettingsPage />} />
          <Route path='/tasks/my' element={<MyTasksPage />} />
          <Route path='/todo' element={<Navigate to='/tasks/my' replace />} />
          <Route path='/finance/report' element={<ReportFinancialPage />} />
          <Route path='/finance/transactions' element={<FinanceTransactions />} />
          <Route path='/reports' element={<ReportsPage />} />
          <Route path='/inventory' element={<InventoryDashboardPage />} />
          <Route path='/inventory/catalogs' element={<InventoryCatalogsPage />} />
          <Route path='/inventory/items' element={<InventoryItemsPage />} />
          <Route path='/inventory/stores' element={<InventoryStoresPage />} />
          <Route path='/inventory/stock-balance' element={<InventoryStockBalancePage />} />
          <Route path='/inventory/stock-transaction' element={<InventoryStockTransactionPage />} />
          <Route path='/inventory/requests' element={<InventoryRequestsPage />} />
          <Route path='/inventory/purchasing' element={<InventoryPurchasingPage />} />
          <Route path='/inventory/receipts' element={<InventoryReceiptsPage />} />
          <Route path='/inventory/allocation' element={<InventoryAllocationPage />} />
          <Route path='/inventory/issues' element={<InventoryIssuesPage />} />
          <Route path='/inventory/returns' element={<InventoryReturnsPage />} />
          <Route path='/inventory/stocktakes' element={<InventoryStocktakesPage />} />
          <Route path='/inventory/reports' element={<InventoryReportsPage />} />
          <Route path='/stock' element={<Navigate to='/inventory' replace />} />
          <Route path='/item' element={<Navigate to='/inventory/items' replace />} />
          <Route path='/bom' element={<Navigate to='/inventory/allocation' replace />} />
          <Route path='/timekeepings' element={<TimekeepingPage />} />
          <Route path='/timekeepings/detail' element={<TimekeepingDetailPage />} />
          <Route path='/timekeepings/timesheets' element={<TimesheetPage />} />
         
          <Route path='/main' element={<MainPage />} />
          <Route path='/manage-orders' element={<ManageOrdersPage />} />
          <Route path='*' element={<Navigate to='/error/404' replace />} />
        </Routes>
      </Suspense>
    </ProtectedRoute>
  )
}
